import { AlertTriangle, RefreshCw, Inbox, Loader2 } from 'lucide-react'

// Shared page-state building blocks so every list shows the same loading /
// error / empty treatment (and errors are never disguised as empty lists).

export function PageHeader({ title, description, actions, eyebrow }) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-8">
      <div className="min-w-0">
        {eyebrow && <p className="text-[12px] font-medium text-[#8b8d94] mb-1.5">{eyebrow}</p>}
        <h1 className="dash-title">{title}</h1>
        {description && <p className="mt-2 text-[14px] text-[#8b8d94] max-w-2xl leading-relaxed">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div>}
    </div>
  )
}

export function LoadingState({ label = 'Loading' }) {
  return (
    <div className="flex items-center justify-center gap-3 py-20 text-[#8b8d94] text-[14px]">
      <Loader2 className="w-5 h-5 animate-spin" /> {label}
    </div>
  )
}

export function ErrorState({ error, onRetry, compact = false }) {
  const message = error?.message || String(error || 'Something went wrong')
  return (
    <div className={'dash-card flex flex-col items-center text-center ' + (compact ? 'py-8 px-5' : 'py-14 px-6')}>
      <span className="w-11 h-11 rounded-full bg-[#e5233b]/15 text-[#ff6b7d] flex items-center justify-center mb-4"><AlertTriangle className="w-5 h-5" /></span>
      <p className="text-[15px] text-white font-medium">Couldn't load this</p>
      <p className="mt-1.5 text-[13px] text-[#8b8d94] max-w-md">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="dash-btn dash-btn-ghost dash-btn-sm mt-5"><RefreshCw className="w-3.5 h-3.5" /> Try again</button>
      )}
    </div>
  )
}

export function EmptyState({ icon: Icon = Inbox, title = 'Nothing here yet', children, action }) {
  return (
    <div className="dash-card flex flex-col items-center text-center py-14 px-6">
      <span className="w-11 h-11 rounded-full bg-white/[0.06] text-[#8b8d94] flex items-center justify-center mb-4"><Icon className="w-5 h-5" /></span>
      <p className="text-[15px] text-white font-medium">{title}</p>
      {children && <div className="mt-1.5 text-[13px] text-[#8b8d94] max-w-md">{children}</div>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}
